import * as React from "react";
import { Link } from "gatsby";
import logoImg from "../images/footer-logo-02.svg";
import useFooter from "../hooks/useFooter2";
import NewsletterForm from "./forms/newsletter";
//import topBtn from "../images/top-btn.png"

//const isProduction = `${process.env.GATSBY_ACTIVE_ENV}` === "production";

const Footer = ({ showMenus }) => {
  const today = new Date();

  const { menu, legal, options } = useFooter();

  return (
    <footer className="pt-12 lg:pt-12 pb-4 print:hidden md:pb-12 bg-[#282D33]">
      <div className="container flex flex-col lg:flex-row justify-between">
        <div className="flex flex-col lg:flex-row lg:space-x-8 mb-8 lg:mb-0">
          <div className="mb-12 lg:mb-0">
            <Link to="/">
              <img
                src={logoImg}
                alt="sightfull"
                className="inline"
                loading="lazy"
              />
            </Link>
          </div>

          <div className="">{showMenus && <Menu items={menu} />}</div>
        </div>

        <div className="relative ">
          <div className=" flex flex-col  space-y-5 max-w-[150px]">
            <div className="flex flex-col justify-start   ">
              <Certifications options={options} />
            </div>

            <div className="">
              <NewsletterForm className="text-xs text-white  space-y-1.5 " />
            </div>

            <div className="">
              <Socials
                title={options.socials_title}
                items={options.relationships.socials}
              />
            </div>

            <div className="font-semibold text-xs text-white flex flex-row justify-between">
              
              <Envelop />
              <a href="mailto:hello@sightfull.com">hello@sightfull.com</a>
            </div>
          </div>
        </div>
      </div>

      <div className="container flex flex-col lg:flex-row lg:justify-left  text-sm lg:text-xs mt-6 ">
        <div className="w-[157px] md:mr-[15px]"></div>
        {legal.map((item, index) => (
          <Link
            key={index}
            to={item.url}
            className="py-4 lg:py-0 lg:mx-4 text-[#727C8D] h-12 lg:h-auto "
          >
            {item.label}
          </Link>
        ))}

        <div className="w-[124px] hidden lg:block"></div>

        {/* <div className="mt-1 font-semibold text-xs text-[#28293D] ml-auto">
          <a href="mailto:hello@sightfull.com">hello@sightfull.com</a>
        </div> */}
      </div>
      <div className="container flex flex-col items-end md:-mt-4">
        <div className="text-[#828282] text-xs my-4 lg:my-0">
          © {today.getFullYear()} {options.copyright}
        </div>
      </div>
    </footer>
  );
};

// const handleClick = () => {
//   window[`scrollTo`]({ top: 0, behavior: `smooth` })
// }

const Menu = ({ items }) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6 text-sm lg:text-xs text-white lg:-mt-[0.4rem]">
      {items.map((m, i) => (
        <React.Fragment key={i}>
          <div className="">
            <h4 className="uppercase font-bold min-h-4 text-[12px]">
              {m.label} &nbsp;
            </h4>

            <div>
              {m.items.map((e, j) => (
                <div className="my-3 text-white  " key={j}>
                  <MenuSubTitle {...e} />
                  <MenuLink {...e} />
                </div>
              ))}
            </div>
          </div>

          {i === 0 && <div className="lg:hidden" key="iplus"></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

const MenuLink = ({ url, label }) => {
  return url === "" || url === null ? (
    false
  ) : (
    <>
      {!url.startsWith("https://") && (
        <h5>
          <Link
            to={url}
            className="text-sm lg:text-xs inline-block font-normal "
          >
            {label}
          </Link>
        </h5>
      )}
      {url.startsWith("https://") && (
        <h5>
          <a
            href={url}
            target="__blank"
            className="text-sm lg:text-xs inline-block font-normal "
          >
            {label}
          </a>
        </h5>
      )}
    </>
  );
};

const MenuSubTitle = ({ url, label }) => {
  return url === "" || url === null ? (
    <h5 className="font-semibold text-[12px]">{label}</h5>
  ) : (
    false
  );
};

const Certifications = ({ options }) => {
  return (
    <div className="flex  text-xs justify-between  items-center ">
      {options.relationships.certifications.map((m, i) => (
        <div key={i} className="">
          <img
            src={m.uri.url}
            alt={options.certAlt[i].alt}
            width="50px"
            height="63"
            loading="lazy"
            className=""
          />
        </div>
      ))}
    </div>
  );
};

const Socials = ({ title, items }) => {
  return (
    <div className="flex justify-between  text-xs items-center">
      <div className="uppercase mt-1 font-semibold text-xs text-white">
        {title}
      </div>
      <div className="flex justify-end gap-3 items-center">
        {items.map((m, i) => (
          <div key={i} className="">
            <a href={m.link.uri} target="_blank" rel="noreferrer">
              <img
                src={m.relationships.image.uri.url}
                alt={m.image.alt}
                width="18px"
                height="18px"
                loading="lazy"
                className="mr-0.5 "
              />
              {/* <img
            src={m.relationships.image.uri?.url}
            alt={m.image.alt}
            width="48px"
            height="48px"
            loading="lazy"
            className="mr-0.5 lg:hidden"
          /> */}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};


const Envelop = () => {
  return (
    <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.8333 3.03784H3.16659C2.43021 3.03784 1.83325 3.6348 1.83325 4.37118V12.3712C1.83325 13.1076 2.43021 13.7045 3.16659 13.7045H13.8333C14.5696 13.7045 15.1666 13.1076 15.1666 12.3712V4.37118C15.1666 3.6348 14.5696 3.03784 13.8333 3.03784Z"
                  stroke="#fff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15.1666 5.03784L9.18658 8.83784C8.98077 8.96679 8.7428 9.03518 8.49992 9.03518C8.25704 9.03518 8.01907 8.96679 7.81325 8.83784L1.83325 5.03784"
                  stroke="#fff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
  )
}
export default Footer;
